import { Badges, H5, H6, P } from "../../../../AbstractElements";
import { Resolutions } from "../../../../Constants/Constants";

const ResolutionTimeline = () => {
  return (
    <div className="cd-timeline-block">
      <div className="cd-timeline-img cd-movie bg-danger">
        <i className="icon-agenda" />
      </div>
      <div className="cd-timeline-content">
        <div className="timeline-wrapper">
          <Badges color="warning">{Resolutions}</Badges>
        </div>
        <H5 className="m-0">{"My Resolutions for 2024 "}</H5>
        <P className="mb-0">{"I'm determined to streamline, organism, systematism, realign, and embrace life in 2024."}</P>
        <div className="time-content pt-2 d-flex">
          <i className="icon-write me-2"></i>
          <H6>{" My Resolutions"}</H6>
        </div>
        <span className="cd-date">December 31 2024 </span>
      </div>
    </div>
  );
};
export default ResolutionTimeline;
